import { UnifiedAlarmMessageType } from '@hakimo-ui/hakimo/types';
import { useAlarmDetailWs } from '@hakimo-ui/hakimo/util';
import { useEffect } from 'react';

export function useUnifiedAlarmWsMessageHandler(
  messageType: UnifiedAlarmMessageType,
  handler: (data: any) => void
) {
  const { subscribe } = useAlarmDetailWs();

  useEffect(() => {
    // Subscribe to messages with type 'update' (or any other topic)
    const unsubscribe = subscribe?.(messageType, handler);
    return () => {
      unsubscribe?.();
    };
  }, [handler, messageType, subscribe]);
}
